import React from 'react';
import { useSnackbar } from 'notistack';

import { VpSnackbar } from '../components';

export const useVpSnackbar = () => {
  const { enqueueSnackbar } = useSnackbar();

  const addSnackbar = ({ message, severity, onClose = null, ...rest }) => {
    enqueueSnackbar(message, {
      content: (key, message) => {
        return <VpSnackbar id={key} message={message} severity={severity} {...rest} />;
      },
      onClose
    });
  };

  const addSnackbarError = ({
    error,
    persist = false,
    autoHideDuration = 7500,
    onClose = null,
    ...rest
  }) => {
    const message = error?.response?.data?.message || 'An error occurred';
    enqueueSnackbar(message, {
      content: (key, message) => {
        return <VpSnackbar id={key} message={message} title="Error" severity="error" {...rest} />;
      },
      persist,
      autoHideDuration,
      onClose
    });
  };

  const addSnackbarSuccess = ({
    message,
    severity = 'success',
    title = 'Completed',
    onClose = null,
    ...rest
  }) => {
    enqueueSnackbar(message, {
      content: (key, message) => {
        return (
          <VpSnackbar id={key} message={message} severity={severity} title={title} {...rest} />
        );
      },
      onClose
    });
  };

  const addSnackbarInfo = ({
    message,
    severity = 'info',
    title = '',
    onClose = null,
    autoHideDuration = 7500,
    ...rest
  }) => {
    enqueueSnackbar(message, {
      content: (key, message) => {
        return (
          <VpSnackbar id={key} message={message} severity={severity} title={title} {...rest} />
        );
      },
      autoHideDuration,
      onClose
    });
  };

  return {
    addSnackbarError,
    addSnackbarSuccess,
    addSnackbarInfo,
    addSnackbar
  };
};



// WEBPACK FOOTER //
// ./src/vp-ui/hooks/useVpSnackbar.js